<div class="header">
    <label *ngIf="label">{{ label }}</label>
    <app-icon library="fontawesome" variant="fa-plus" (click)="addInput()"></app-icon>
</div>
<div class="input-field">
    <div class="input-list" *ngFor="let form of formGroup;let i = index">
        <div class="input-list-item">
            <form class="input-form">
                <app-input [formControl]="form?.controls?.name"
                           [placeholder]="placeholder"
                           [(ngModel)]="inputs[i].name"
                           [showErrors]="showErrors">
                </app-input>
            </form>
            <app-icon library="fontawesome" variant="fa-minus" type="danger" (click)="removeInput(i)"></app-icon>
        </div>
    </div>
</div>
